// Imports: local files.
import {
  GET_ALL_SURVEYS_START,
  GET_ALL_SURVEYS_SUCCESS,
  GET_ALL_SURVEYS_FAILED,
  GET_ALL_SURVEYS_RESET,
  GET_ONE_SURVEY_START,
  GET_ONE_SURVEY_SUCCESS,
  GET_ONE_SURVEY_FAILED,
  GET_ONE_SURVEY_RESET,
  UPDATE_ONE_SURVEY_START,
  UPDATE_ONE_SURVEY_SUCCESS,
  UPDATE_ONE_SURVEY_FAILED,
  UPDATE_ONE_SURVEY_RESET,
  DELETE_ONE_SURVEY_START,
  DELETE_ONE_SURVEY_SUCCESS,
  DELETE_ONE_SURVEY_FAILED,
  DELETE_ONE_SURVEY_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const surveysReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Surveys
     * =======================================================================
     */
    case GET_ALL_SURVEYS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_SURVEYS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_SURVEYS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_SURVEYS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Survey
     * =======================================================================
     */
    case GET_ONE_SURVEY_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_SURVEY_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_SURVEY_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_SURVEY_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Application
     * =======================================================================
     */
    case UPDATE_ONE_SURVEY_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_SURVEY_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_SURVEY_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_SURVEY_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Survey
     * =======================================================================
     */
    case DELETE_ONE_SURVEY_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_SURVEY_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_SURVEY_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_SURVEY_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default surveysReducer;
